import React, { useState, Fragment, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { selectDeviceName } from 'yoda-site-components/lib/selectors/ContextSelector';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import ImagemapBanner from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import ImageBanner from 'yoda-core-components/lib/components/Banner/Banner';
import { getSkinnyBannerContent } from 'yoda-interfaces/lib/Pdp/SkinnyBanner/SkinnyBannerApi';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const defaultState = {
    isSuccess: false,
    isLoading: true,
    imageUrl: '',
    imageAltText: '',
    imagemapArea: [],
    imageWidth: '',
    imageHeight: '',
};
function SkinnyClientBanner({
    automationId,
    deviceName,
    emptyDivHeight,
    topPromotionalBanner,
    checkBannerData,
}) {
    const [state, setState] = useState(defaultState);
    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const res = await getSkinnyBannerContent({
                    channel: deviceName,
                });

                const bannerData = get(res, 'data.content.components[0].content.channels[0]', null);
                const componentType = get(res, 'data.content.components[0].componentType', '');
                /* istanbul ignore next */
                if (bannerData) {
                    const {
                        image: {
                            dimensions: { width = '', height = '' } = {},
                            url = '',
                            altText = '',
                        } = {},
                        link: { url: linkUrl = '' } = {},
                        linkText = '',
                        openInNewTab = false,
                        hotspots = [],
                    } = bannerData;
                    const deviceval = deviceName?.toLowerCase();
                    checkBannerData !== null &&
                        deviceval !== 'desktop' &&
                        deviceval !== 'tablet' &&
                        checkBannerData(true);
                    setState({
                        ...state,
                        isSuccess: true,
                        isLoading: false,
                        componentType,
                        imageUrl: url,
                        imageAltText: altText,
                        imageWidth: width,
                        imageHeight: height,
                        imagelinkUrl: linkUrl,
                        imagelinkText: linkText,
                        imageOpenNewTab: openInNewTab,
                        imagemapArea: hotspots.map((hotspot = {}) => {
                            // eslint-disable-next-line no-shadow
                            const { link = {}, linkText, openInNewTab } = hotspot;
                            const hotspotData = { ...hotspot };
                            if (link.url) {
                                hotspotData.leaf = !link.url.includes('X2H2');
                                hotspotData.link = link.url;
                            }
                            hotspotData.alt = linkText;
                            hotspotData.target = openInNewTab ? '_blank' : '_self';
                            return hotspotData;
                        }),
                    });
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        isSuccess: false,
                        isLoading: false,
                    }));
                }
            } catch (error) {
                /* istanbul ignore next */
                console.error('Error fetching banner data:', error);
                setState((prevState) => ({
                    ...prevState,
                    isSuccess: false,
                    isLoading: false,
                }));
            }
        };

        fetchBannerData();
    }, [deviceName, checkBannerData]); // Added deviceName to dependency array
    const topbannerSpaceStyle = dt(['smOnly:mb-2', 'mx-0', 'pt-0', 'smOnly:mt-3', 'md:my-2']);
    return (
        <>
            {/* Placeholder to avoid CLS */}
            {state.isLoading && emptyDivHeight && (
                <div
                    style={{
                        minHeight: `${emptyDivHeight}px`,
                    }}
                />
            )}
            {state.isSuccess ? (
                <ErrorBoundary>
                    <div
                        data-automation-id="topbannerSpace"
                        className={topPromotionalBanner && topbannerSpaceStyle}
                    >
                        {state.componentType === 'imagehotspots' ? (
                            <ImagemapBanner
                                automationId={automationId}
                                imageUrl={state.imageUrl}
                                imagemapArea={state.imagemapArea}
                                imageAltText={state.imageAltText}
                                imageWidth={state.imageWidth}
                                imageHeight={state.imageHeight}
                            />
                        ) : (
                            <ImageBanner
                                automationId={automationId}
                                bannerImageUrl={state.imageUrl}
                                bannerImageClass={dt(['!h-25'])}
                                ariaLabel={state.imagelinkText}
                                altText={state.imagelinkText}
                                width={state.imageWidth}
                                height={state.imageHeight}
                                href={state.imagelinkUrl}
                                target={state.imageOpenNewTab ? '_blank' : ''}
                            />
                        )}
                    </div>
                </ErrorBoundary>
            ) : null}
        </>
    );
}

SkinnyClientBanner.propTypes = {
    automationId: PropTypes.string,
    deviceName: PropTypes.string,
    emptyDivHeight: PropTypes.string,
    topPromotionalBanner: PropTypes.bool,
    checkBannerData: PropTypes.func,
};

SkinnyClientBanner.defaultProps = {
    automationId: 'skinny-banner-content',
    deviceName: 'Desktop',
    topPromotionalBanner: false,
    emptyDivHeight: '',
    checkBannerData: null,
};

const mapStateToProps = (state) => ({
    deviceName: selectDeviceName(state),
});

export default memo(connect(mapStateToProps)(SkinnyClientBanner));
